// Copyright (c) 2025 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export const ToS_LINK = 'https://www.iota.org/iota-wallet-tos';
export const FAQ_LINK = 'https://docs.iota.org/about-iota/iota-wallet/FAQ';
